/**
 * Owner: Masa Bayu
 * File: routes.ts
 * Date:Time: 2026-09-18 10:49
 * Description: PRODUCT_ROUTES — /circle · /live · QXRead hash shell.
 */

export const PRODUCT_ROUTES = Object.freeze({
  home: '/',
  qxcircle: '/circle',
  notifications: '/circle/notifications',
  arena: '/live',
  accountRegister: '/account',
  accountSignIn: '/login',
});

export function signInHref(returnTo: string): string {
  return `/login?returnTo=${encodeURIComponent(returnTo)}`;
}
